import React, { useEffect, useState } from "react";
// import { useDispatch, useSelector } from "react-redux";
import { Col, Row, Tabs, Spin, Tooltip, Modal } from "antd";
import ComplianceModal from "./ComplianceModal";
import { useDispatch, useSelector } from "react-redux";
import { HomeOutlined, SettingOutlined } from "@ant-design/icons";
import StAddNew from "../../pages/DSeries/StAddNew";
import { useHistory } from "react-router";
import liracrypt from '../../components/Liracrypt/liracrypt';
import { createRoute } from "../../utils/CustomFunc";
import MultiText from "../../components/MultiText";

const RightIconContainer = (props) => {
  const urlCode = useSelector(state => state.urlCode);
  const [complianceData, setComplianceData] = useState();
  const history = useHistory();
  const dispatch = useDispatch();
  const currentAndonStatus = useSelector(state => state.andonStatus);
  const { TabPane } = Tabs;
  const [skillChart, setSkillChart] = useState(null);
  const [DataModal, setDataModal] = useState({ visible: false, data: null });
  const [showSettingsModal, setShowSettingsModal] = useState(false);

  const [ref, setRef] = useState(true);

  const modalHandler = () => {
    setDataModal({ visible: false, data: null });
  };

  const onClickHandler = (obj) => {
    if (obj.typ === 'newTab') {
      let urlData = { ...obj.params };
      urlData['lid'] = props.selectedLid;
      let route = createRoute({
        route: obj.route,
        params: urlData,
        urlCode
      })
      return window.open(route, "_blank");
    };
    if (obj.typ === 'message') {
      return Modal.confirm({
        title: obj.message,
        okText: 'Ok',
        cancelButtonProps: { hidden: true }
      })
    }
    setDataModal({ visible: true, data: obj });
  };

  const getComplianceData = () => {
    liracrypt.get('/linedash/linedashcompliancedata', { lid: props.selectedLid, proj: 'compliance' })
      .then(response => {
        setComplianceData(response.data.data.compliance)
      })
      .catch(err => {
        console.log(err);
      })
  }

  useEffect(() => {

    getComplianceData();
    let interval = setInterval(() => {
      getComplianceData();
    }, 60000);
    return (() => clearInterval(interval))
  }, []);

  const handleOk = () => {
    setShowSettingsModal(false);
  };

  const handleCancel = () => {
    setShowSettingsModal(false);
  };

  const currentAndonBulb = () => {
    if (currentAndonStatus) {
      let currentBulb = currentAndonStatus.replace(" ", "");
      return currentBulb;
    }
  }

  return (
    <div className="compliance-container">
      {props.aux ? (
        showSettingsModal ?
          <Modal
            title="Auxilliary Menu"
            open={showSettingsModal}
            onOk={handleOk}
            onCancel={handleCancel}
            okButtonProps={{ hidden: true }}
            cancelButtonProps={{ hidden: true }}
            width="60%"
          >
            <Tabs defaultActiveKey={0} type="card" size={"medium"}>
              {Object.keys(props.aux).map((key, ind) => {
                return (
                  <TabPane tab={props.aux[key]["pageName"]} key={ind}>
                    <StAddNew
                      setSelectedLid={props.setSelectedLid}
                      colSpan={24}
                      urlEndpoint={props.aux[key]["urlEndpoint"]}
                      extraData={{ lid: props.selectedLid }}
                      // dictName={props.aux[key]["dictName"]}
                      submitTxt="Save"
                      onCallFinish={() => {
                        setShowSettingsModal(false);
                      }}
                      urlData={{ dictName: props.aux[key]["dictName"] }}
                    />
                  </TabPane>
                );
              })}
            </Tabs>
          </Modal> : <></>
      ) : (
        <></>
      )}

      <Row justify="center" style={{ marginTop: "10px" }}>
        <Col span={24}>
          <div
            style={{
              textAlign: "center",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              minHeight: "100%",
              // paddingTop: "100px",
            }}
          >
            {/* {props.andonstatus != null && props.addonLoaded ? (
              props.andonstatus.andonColor === "R" ? (
                <Tooltip title={"Andon Red"} placement="left">
                  <img
                    alt="andon"
                    src={props.rightContainer.andon.andonColor["r"]}
                    width="100%"
                  />
                </Tooltip>
              ) : props.andonstatus.andonColor === "O" ? (
                <Tooltip title={"Andon Orange"} placement="left">
                  <img
                    alt="andon"
                    src={props.rightContainer.andon.andonColor["o"]}
                    width="100%"
                  />
                </Tooltip>
              ) : (
                <Tooltip title={"Andon Green"} placement="left">
                  <img
                    alt="andon"
                    src={props.rightContainer.andon.andonColor["g"]}
                    width="100%"
                  />
                </Tooltip>
              )
            ) : (
              <Tooltip title={"Andon Green"} placement="left">
                <img
                  alt="andon"
                  src={props.rightContainer.andon.andonColor["g"]}
                  width="100%"
                />
              </Tooltip>
            )} */}
            {
              currentAndonStatus && (
                <Tooltip title={currentAndonStatus} placement="left">
                  <img
                    alt="andon"
                    src={require(`../../images/${currentAndonBulb()}.gif`)}
                    width="100%"
                  />
                </Tooltip>
              )
            }
            <span style={{ textAlign: "center" }}>
              {props.rightContainer.andon.Text}
            </span>
            {complianceData ? (
              <div>
                {complianceData.map((obj, i) => (
                  <div style={{ paddingTop: "10px", position: 'relative' }} key={"imgDiv" + i}>
                    <Tooltip placement="left" title={obj.tootip}>
                      <img
                        key={"img" + i}
                        alt="andon"
                        src={
                          require(`../../assets/static/compliance1/${obj.img}`)
                        }
                        width="70%"
                        loading="eager"
                        style={{
                          cursor: obj.isClickable ? "pointer" : "",
                          marginTop: "10px",
                        }}
                        onClick={() => {
                          if (obj.isClickable) {
                            localStorage.removeItem("CompulseEvents");
                            localStorage.removeItem("LineDashComplianceAttender");
                            localStorage.removeItem("ComplianceStatusTypes");

                            onClickHandler(obj);
                          }
                        }}
                      />
                      {
                        obj.badge?.length ? 
                        <MultiText data={obj.badge} /> : <></>
                      }
                      
                    </Tooltip>
                  </div>
                ))}
              </div>
            ) : null}
          </div>

          <ComplianceModal
            data={DataModal}
            modalHandler={modalHandler}
            selectedLid={props.selectedLid}
            refreshLineDashboard={props.refreshLineDashboard}
          />
        </Col>
      </Row>
      <div style={{ marginBottom: 10 }}>
        {props.aux ? (
          <Row justify="center">
            <Col style={{ marginBottom: "25px" }}>
              <Tooltip title={"Auxilliary Menu"} placement="left">
                <SettingOutlined
                  style={{ fontSize: 40, color: "rgb(127, 127, 127)" }}
                  onClick={() => setShowSettingsModal(true)}
                  onCallFinish={() => setShowSettingsModal(false)}
                  spin={showSettingsModal}
                />
              </Tooltip>
            </Col>
          </Row>
        ) : (
          <></>
        )}
        <Row justify="center">
          <Col>
            <Tooltip title={"Home"} placement="left">
              <HomeOutlined
                style={{ fontSize: 40, color: "rgb(127, 127, 127)" }}
                onClick={() => history.push(localStorage.getItem("homePage") || `/v02/${urlCode}/dashboard`)}
              />
            </Tooltip>
          </Col>
        </Row>
      </div>
    </div>
  );
};
export default RightIconContainer;
